// extracted by mini-css-extract-plugin
export default {"form":"company-details_form__6A-jB"};